/* AmberCares duo route. Original Shopify variants and Easify validation stay in charge. */
(() => {
  'use strict';
  const configNode = document.getElementById('ac-duo-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const params = new URLSearchParams(location.search);
  const storageKey = 'ambercares-duo-v1';
  const money = cents => new Intl.NumberFormat('nl-NL', {style:'currency',currency:'EUR'}).format(cents / 100);
  const read = () => {try {const s=JSON.parse(sessionStorage.getItem(storageKey)); return s && config.pairs[s.pair] && Date.now()-s.created<86400000 ? s : null;} catch (_) {return null;}};
  const write = state => {try {sessionStorage.setItem(storageKey,JSON.stringify(state));} catch (_) { /* URL retains the non-personal flow reference. */ }};
  const newId = () => typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
  const url = (path, extra={}) => {
    const u=new URL(path,location.origin);
    for (const k of ['preview_theme_id','_fd','_sc']) if(params.has(k)) u.searchParams.set(k,params.get(k));
    for(const [k,v] of Object.entries(extra)) u.searchParams.set(k,v);
    return u.pathname+u.search;
  };
  const productURL = (state,step) => url(root+'products/'+config.products[config.pairs[state.pair][step-1]].handle,{ac_duo:state.pair,ac_step:step,ac_flow:state.id});
  const getCart = async () => {
    const r=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error('Je winkelwagen kan even niet worden gecontroleerd.');
    return r.json();
  };
  const lines = (cart,state,step) => cart.items.filter(item => {
    const p=item.properties||{};
    return p._ac_duo_id===state.id && String(p._ac_duo_step)===String(step) && String(item.variant_id)===config.products[config.pairs[state.pair][step-1]].variant && item.quantity>0;
  });
  const link = (text,href,className='ac-duo-flow__resume') => {const a=document.createElement('a');a.textContent=text;a.href=href;a.className=className;return a;};
  document.addEventListener('click',async e=>{
    const start=e.target.closest('[data-ac-duo-start]');
    if(!start || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button) return;
    const pair=start.dataset.acDuoStart;
    if(!config.pairs[pair]) return;
    e.preventDefault();
    if(start.dataset.busy) return;
    start.dataset.busy='true';start.setAttribute('aria-busy','true');
    let state=read();
    if(!state || state.pair!==pair) state={pair,id:newId(),created:Date.now(),pending:0};
    write(state);
    let step=1;
    try {const cart=await getCart();if(lines(cart,state,1).length) step=2;} catch (_) { /* First page can still load and explain connectivity issues. */ }
    location.assign(productURL(state,step));
  });

  const pair=params.get('ac_duo');
  const step=Number(params.get('ac_step'));
  let state=read();
  if(!config.pairs[pair] || ![1,2].includes(step)) {
    // Recover a normal cart-page redirect after Easify has saved the product.
    if(location.pathname.replace(/\/$/,'')===root+'cart' && state && state.pending) {
      getCart().then(cart=>{
        if(!lines(cart,state,state.pending).length) return;
        const next=state.pending===1?2:state.pending;
        state.pending=0;write(state);location.replace(productURL(state,next));
      }).catch(()=>{});
    }
    return;
  }
  const target=config.products[config.pairs[pair][step-1]];
  if(!location.pathname.endsWith('/products/'+target.handle)) return;
  const fromURL=params.get('ac_flow');
  if(!state || state.pair!==pair || (fromURL && state.id!==fromURL)) {
    state={pair,id:fromURL && /^[a-zA-Z0-9-]{8,80}$/.test(fromURL)?fromURL:newId(),created:Date.now(),pending:0};
  }
  write(state);
  if(!fromURL) history.replaceState(null,'',productURL(state,step));
  let form,button,panel,status,completed=false,checking=false,advancing=false,timer,attemptUntil=0,initialReady=false;
  const message = text => {if(status) status.textContent=text;};
  const setButton = text => {
    if(!button || button.disabled) return;
    const label=button.querySelector('[data-add-to-cart-text]');
    if(label) {if(label.textContent!==text) label.textContent=text;}
    else if(button.textContent.trim()!==text) button.textContent=text;
  };
  const review = cart => {
    completed=true;state.pending=0;write(state);clearTimeout(timer);
    if(button) {button.disabled=true;button.setAttribute('aria-disabled','true');}
    panel.querySelectorAll('[data-duo-result]').forEach(n=>n.remove());
    const first=lines(cart,state,1),second=lines(cart,state,2);
    if(step===1) {
      message('Deze legging is al ingevuld en staat in je winkelwagen. Je hoeft haar niet opnieuw toe te voegen.');
      const a=link('Verder met legging 2 →',productURL(state,2));a.dataset.duoResult='true';panel.append(a);return;
    }
    if(!first.length) {
      message('Legging 2 is opgeslagen. Vul ook legging 1 in om je duo compleet te maken.');
      const a=link('Vul legging 1 in →',productURL(state,1));a.dataset.duoResult='true';panel.append(a);return;
    }
    const a=link('Controleer je winkelwagen →',url(root+'cart'));a.dataset.duoResult='true';panel.append(a);
    const allDiscounts=cart.items.flatMap(i=>i.line_level_discount_allocations||[]);
    const hasDiscount=allDiscounts.some(d=>(d.discount_application?.title||'')===config.discountTitle && d.amount>0);
    const total=[...first,...second].reduce((sum,i)=>sum+i.final_line_price,0);
    message(hasDiscount?'Beide leggingen zijn opgeslagen. Jouw duo kost '+money(total)+'. Het duovoordeel is toegepast.':'Beide leggingen zijn opgeslagen. Controleer de toegepaste korting en het totaal in je winkelwagen.');
    if(hasDiscount) {
      const checkout=link('Samen afrekenen →',root+'checkout','ac-duo-cta');checkout.dataset.duoResult='true';panel.append(checkout);
    }
  };
  const check = async (advance=false) => {
    if(checking || advancing || !form) return;
    checking=true;
    try {
      const cart=await getCart();
      const current=lines(cart,state,step);
      if(current.length) {
        state.pending=0;write(state);clearTimeout(timer);
        if(advance && step===1) {
          advancing=true;message('Legging 1 is opgeslagen. Je gaat nu naar legging 2…');location.assign(productURL(state,2));
        } else if(advance && step===2 && lines(cart,state,1).length) {
          review(cart);
          const discounted=cart.items.flatMap(i=>i.line_level_discount_allocations||[]).some(d=>d.discount_application?.title===config.discountTitle && d.amount>0);
          if(discounted) {advancing=true;location.assign(root+'checkout');}
          else {message('Je duo staat klaar. Je gaat naar de winkelwagen om de korting en het totaal te bekijken.');advancing=true;location.assign(url(root+'cart'));}
        } else review(cart);
      } else if(step===2 && !lines(cart,state,1).length) {
        message('Legging 1 staat nog niet in je winkelwagen. Vul die eerst in; daarna kun je hier verder.');
        if(button) button.disabled=true;
        if(!panel.querySelector('[data-duo-result]')) {const a=link('Eerst legging 1 invullen →',productURL(state,1));a.dataset.duoResult='true';panel.append(a);}
      } else {
        initialReady=true;if(button) button.disabled=false;
      }
    } catch (_) {
      message('Je winkelwagen kon nog niet worden gecontroleerd. Vernieuw deze pagina of bekijk je winkelwagen voordat je opnieuw toevoegt.');
      if(!panel.querySelector('[data-duo-recovery]')) {const a=link('Bekijk je winkelwagen →',url(root+'cart'));a.dataset.duoRecovery='true';panel.append(a);}
    } finally {checking=false;}
  };
  const poll = async () => {
    await check(true);
    if(completed || advancing) return;
    if(Date.now()<attemptUntil) timer=setTimeout(poll,1000);
    else {state.pending=0;write(state);message('Nog niet toegevoegd. Controleer de verplichte velden en eventuele foutmelding bij het formulier.');}
  };
  const arm = e => {
    if((e.type==='submit' && e.target!==form) || (e.type==='click' && !e.target.closest('button[name="add"],input[name="add"]'))) return;
    if(e.type==='click' && e.target.closest('form')!==form) return;
    if(completed || advancing || !initialReady) {e.preventDefault();e.stopImmediatePropagation();return;}
    if(state.pending===step && Date.now()<attemptUntil) return;
    state.pending=step;write(state);attemptUntil=Date.now()+22000;
    // No preventDefault here: Easify performs its own required/conditional validation.
    clearTimeout(timer);timer=setTimeout(poll,800);
  };
  const mount = () => {
    if(!form) form=Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(f=>{
      const id=f.querySelector('[name="id"]');return id && String(id.value)===target.variant;
    });
    if(!form) return;
    for(const [key,value] of Object.entries({_ac_duo_id:state.id,_ac_duo_step:String(step),_ac_duo:pair,_ac_duo_document:'gezamenlijk-v1',...(config.duoSkus?.[pair]?{_ac_duo_sku:config.duoSkus[pair]}:{})})) {
      const name='properties['+key+']';let field=Array.from(form.elements).find(el=>el.name===name);
      if(!field) {field=document.createElement('input');field.type='hidden';field.name=name;form.append(field);}
      if(field.value!==value) field.value=value;
    }
    button=form.querySelector('button[name="add"],input[name="add"]');
    if(!panel) {
      document.body.classList.add('ac-duo-active');
      panel=document.createElement('section');panel.className='ac-duo-flow';panel.setAttribute('aria-label','Jouw leggingenduo');
      panel.innerHTML='<div class="ac-duo-flow__top"><strong>Jouw leggingenduo</strong></div><div class="ac-duo-flow__steps"><span'+(step===1?' class="is-current" aria-current="step"':'')+'><b>1</b>Legging 1</span><span aria-hidden="true">→</span><span'+(step===2?' class="is-current" aria-current="step"':'')+'><b>2</b>Legging 2</span><span aria-hidden="true">→</span><span><b>3</b>Afrekenen</span></div>';
      panel.querySelector('.ac-duo-flow__top').append(link('Alle duo’s',url(root+'pages/leggingenduos'),''));
      const h=document.createElement('h2');h.textContent='Stap '+step+' · '+target.name;panel.append(h);
      const p=document.createElement('p');p.textContent=step===1?'Vul hieronder jouw gegevens en vragen voor de eerste legging in. Daarna ga je automatisch verder met '+config.products[config.pairs[pair][1]].name+'.':'Vul nu het tweede formulier in. Je rekent beide leggingen samen af met duovoordeel en ontvangt één uitgebreid document waarin beide onderwerpen samenkomen.';panel.append(p);
      status=document.createElement('p');status.className='ac-duo-flow__status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');panel.append(status);
      form.before(panel);
      document.addEventListener('click',arm,true);document.addEventListener('submit',arm,true);
      document.addEventListener('ajaxProduct:added',e=>{
        if(!state.pending || !e.detail?.addToCartBtn || !form.contains(e.detail.addToCartBtn)) return;
        e.stopImmediatePropagation();check(true);
      },true);
      for(const name of ['easify:main-product:add','easify:added']) document.addEventListener(name,()=>{if(state.pending) check(true);});
      document.addEventListener('ajaxProduct:error',()=>{if(state.pending){clearTimeout(timer);state.pending=0;write(state);message('Het toevoegen is niet gelukt. Controleer de melding bij het formulier.');}});
      if(button) button.disabled=true;
      check(Boolean(state.pending));
    }
    if(!completed && !advancing) setButton(step===1?'Opslaan & naar legging 2 →':'Opslaan & samen afrekenen →');
  };
  mount();
  // Easify renders asynchronously; observe just the product area, not unrelated cart widgets.
  const host=document.querySelector('#MainContent')||document.body;
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;mount();});}).observe(host,{childList:true,subtree:true});
  window.addEventListener('pageshow',e=>{if(e.persisted){advancing=false;completed=false;check(false);}});
})();

/* Two Easify sections, one unchanged Shopify product form. */
(() => {
  'use strict';
  const variant = '59099602059599';
  let observer;
  function init() {
    const input = document.querySelector('[name="properties[Plan focus]"]');
    if (!input) return false;
    const form = input.form;
    if (!form || String(form.querySelector('[name="id"]')?.value) !== variant) return false;
    const set = input.closest('.tpo_option-set-container');
    if (!set || set.dataset.acPlanReady) return !!set;
    const rows = [...set.querySelectorAll('.tpo_option-container')];
    const split = rows.indexOf(input.closest('.tpo_option-container'));
    if (split < 1 || rows.length < 9) return false;
    set.dataset.acPlanReady = 'true';
    form.classList.add('ac-plan-form');
    const first = rows.slice(0, split), second = rows.slice(split);
    const header = document.createElement('section');
    header.className = 'ac-plan-steps';
    header.innerHTML = '<p class="ac-plan-steps__eyebrow">Jouw duo · twee onderdelen, één persoonlijk document</p><ol><li>1 · Jaarlegging 2027</li><li>2 · Persoonlijk Plan</li></ol><h2 tabindex="-1"></h2><p class="ac-plan-steps__intro"></p>';
    set.before(header);
    const nav = document.createElement('div');
    nav.className = 'ac-plan-nav';
    nav.innerHTML = '<p class="ac-plan-error" role="alert"></p><button type="button" class="ac-plan-next">Verder naar jouw Persoonlijk Plan <span aria-hidden="true">→</span></button><button type="button" class="ac-plan-back">← Terug naar je jaarlegging</button><p class="ac-plan-summary">Je ontvangt beide onderdelen in één persoonlijk document. Jouw antwoorden uit stap 1 blijven bewaard.</p>';
    set.after(nav);
    let step = 1;
    const submitButtons = [...form.querySelectorAll('[type="submit"], [name="add"], .shopify-payment-button')];
    const next = nav.querySelector('.ac-plan-next'), back = nav.querySelector('.ac-plan-back');
    const error = nav.querySelector('.ac-plan-error');
    const required = group => group.flatMap(row => [...row.querySelectorAll('[data-required="1"], [required]')]).find(el => !el.disabled && !String(el.value || '').trim());
    function show(n, focus) {
      step = n;
      form.dataset.acPlanStep = String(n);
      first.forEach(row => row.classList.toggle('ac-plan-hidden', n !== 1));
      second.forEach(row => row.classList.toggle('ac-plan-hidden', n !== 2));
      submitButtons.forEach(button => button.classList.toggle('ac-plan-hidden', n !== 2));
      next.hidden = n !== 1; back.hidden = n !== 2;
      nav.querySelector('.ac-plan-summary').hidden = n !== 2;
      [...header.querySelectorAll('li')].forEach((li, i) => { if (i === n - 1) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current'); });
      header.querySelector('h2').textContent = n === 1 ? 'Eerst jouw Jaarlegging 2027' : 'Nu jouw Persoonlijk Plan';
      header.querySelector('.ac-plan-steps__intro').textContent = n === 1 ? 'Vertel wat je wilt meenemen in je jaarlegging. Daarna gaan we verder met jouw plan.' : 'Waar wil jij zelf richting aan geven? Ik werk jouw plan uit op basis van je jaarlegging. Een korte toelichting is genoeg.';
      error.textContent = '';
      if (focus) { header.scrollIntoView({block: 'start', behavior: 'auto'}); header.querySelector('h2').focus({preventScroll: true}); }
    }
    function missing(el) {
      error.textContent = 'Vul eerst het verplichte veld “' + (el.getAttribute('aria-label') || 'jouw antwoord') + '” in.';
      el.focus(); el.scrollIntoView({block: 'center', behavior: 'auto'});
    }
    next.addEventListener('click', () => { const el = required(first); if (el) return missing(el); show(2, true); });
    back.addEventListener('click', () => show(1, true));
    form.addEventListener('click', e => {
      if (step === 1 && e.target.closest('[name="add"], [type="submit"]')) {
        e.preventDefault(); e.stopImmediatePropagation(); next.click();
      }
    }, true);
    // Prevent Enter in an input from skipping a step; Easify retains final validation.
    form.addEventListener('submit', e => {
      if (step === 1) { e.preventDefault(); e.stopImmediatePropagation(); next.click(); return; }
      const el = required(first);
      if (el) { e.preventDefault(); e.stopImmediatePropagation(); show(1, true); missing(el); }
    }, true);
    show(1, false);
    return true;
  }
  if (init()) return;
  observer = new MutationObserver(() => { if (init()) observer.disconnect(); });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  setTimeout(() => observer.disconnect(), 30000);
})();
